module.exports = __webpack_public_path__ + "img/wggg(5).654cf860.jpg";